import React from 'react';
import ReactDOM from 'react-dom/client';
import Dashboard from './App';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { MapRegionsProvider } from './context/MapRegionsContext';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find root element');
}

// AuthProvider must wrap ThemeProvider so the latter can read user.theme_preference
// and user.tenant_brand_accent to apply server-stored theme + brand on hydration.
//
// MapRegionsProvider holds this tenant's turfs (GET /geo/regions), which used
// to be a hardcoded Platte constant in the bundle. It reads the token rather
// than AuthContext, so its position relative to the other two is free; it sits
// innermost because only the dashboard consumes it.
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <AuthProvider>
      <ThemeProvider>
        <MapRegionsProvider>
          <Dashboard />
        </MapRegionsProvider>
      </ThemeProvider>
    </AuthProvider>
  </React.StrictMode>
);
